import {
    ComponentFactory, Type, Injector,
    ComponentFactoryResolver,
    NgZone
} from '@angular/core';
import { IContextService } from '../../interfaces/context.abstract.service';
import { PershingTranslationService } from '../../services/pershing-translation.service';
import { CustomElementStrategyBase } from './custom-elements-factory';
import { ElementsConstants } from './elements-constants';
import { UserContext } from '../../models';
import { isIE11orEDGE } from './utils';
export class PershingCustomElementStrategy extends CustomElementStrategyBase {
    ngZone: any;
    config: any;
    setConfig(config: any) {
        this.config = config;
    }
    customConnectCallBack(element: HTMLElement) {
        this.initialize();
        this.addPortalListeners();
        super.connect(element);
    }
    connect(element: HTMLElement) {
        if (isIE11orEDGE()) {
            this.runInZone(() => {
                console.log('Connect will be run inside zone ');
                this.customConnectCallBack(element);
            });
        } else {
            this.customConnectCallBack(element);
        }
    }

    customDisConnectCallBack() {
        this.removePortalListeners();
        super.disconnect();
    }

    disconnect() {
        if (isIE11orEDGE()) {
            this.runInZone(() => {
                console.log('DisConnect will be run inside zone ');
                this.customDisConnectCallBack();
            });
        } else {
            this.customDisConnectCallBack();
        }
    }
    getInputValue(propName: string) {
        if (isIE11orEDGE()) {
            this.runInZone(() => {
                console.log('getInputValue will be run inside zone ');
                return super.getInputValue(propName);
            });
        } else {
            return super.getInputValue(propName);
        }
    }
    setInputValue(propName: string, value: string): void {
        if (isIE11orEDGE()) {
            this.runInZone(() => {
                console.log('setInputValue will be run inside zone ');
                super.setInputValue(propName, value);
            });
        } else {
            super.setInputValue(propName, value);
        }
    }
    private runInZone(fn: () => any) {
        if (!this.ngZone) { this.ngZone = this.injector.get<NgZone>(NgZone); }
        return this.ngZone.run(fn);
    }
    initialize() {
        const pershingAppSettings = (window as any).pershingAppSettings;
        console.log('Pershing Element Strategy  Initialize Method Elements ', pershingAppSettings.eventPayload);
        if (pershingAppSettings && pershingAppSettings.eventPayload && pershingAppSettings.eventPayload.initializationParams) {
            const initializationParams = pershingAppSettings.eventPayload.initializationParams;
            if (initializationParams.contextService) {
                const rootAppcontextService: IContextService = initializationParams.contextService;
                if (rootAppcontextService) {
                    console.log('Pershing Element Strategy getUserContext ', rootAppcontextService.getUserContext());
                    const userContext: UserContext = rootAppcontextService.getUserContext();
                    const elementsContextService = this.injector.get(IContextService);
                    elementsContextService.setUserContext(userContext);
                }
            }
        }
    }

    setContext() {
        const pershingAppSettings = (window as any).pershingAppSettings;
        if (pershingAppSettings && pershingAppSettings.eventPayload) {
            const updateContext = this.config.listeners ? this.config.listeners.indexOf('context') !== -1 ? true : false : false;
            const contextService = this.injector.get(IContextService);
            const eventPayload = pershingAppSettings.eventPayload;
            console.log('Pershing Element Strategy routeContext in Element Module ', eventPayload.routeContext);
            contextService.setRouteContext(eventPayload.routeContext);
            if (updateContext) {
                console.log('Pershing Element Strategy domain context in Element Module ', eventPayload.context);
                contextService.setDomainContext(eventPayload.context.domain, eventPayload.context.value);
            }
        }
    }
    addPortalListeners() {
        this.setContext();
        document.addEventListener(ElementsConstants.ELEMENTS_CONTEXT_CHANGE_EVENT, this.contextChangeEvent);
        document.addEventListener(ElementsConstants.ELEMENTS_LANGUAGE_EVENT, this.languageChange);
    }

    removePortalListeners() {
        console.log('  Remove Portal Listeners ');
        document.removeEventListener(ElementsConstants.ELEMENTS_CONTEXT_CHANGE_EVENT, this.contextChangeEvent, false);
        document.removeEventListener(ElementsConstants.ELEMENTS_LANGUAGE_EVENT, this.languageChange, false);
    }
    contextChangeEvent = () => {
        this.setContext();
    }

    languageChange = (event) => {
        const translationService = this.injector.get(PershingTranslationService);
        const eventDetail = (event as CustomEvent).detail;
        console.log('Pershing Element Strategy for Language Change ', eventDetail.language);
        translationService.use(eventDetail.language);
    }

}
// export class PershingComponentStrategyFactory implements NgElementStrategyFactory {
export class PershingComponentStrategyFactory {
    componentFactory: ComponentFactory<any>;

    constructor(component: Type<any>, private config: any) {
        const injector = config.injector;
        this.componentFactory =
            injector.get(ComponentFactoryResolver).resolveComponentFactory(component);
    }

    create(injector: Injector) {
        const strategy = new PershingCustomElementStrategy(this.componentFactory, injector);
        strategy.setConfig(this.config);
        return strategy;
    }
}
